export default __webpack_public_path__ + "static/media/clip.2351af55.svg";